module.exports = __webpack_public_path__ + "static/media/prev.444bc080.svg";